import { Col, Row } from 'antd';
import * as React from 'react';
import { RouteProps } from 'react-router-dom';
import styled from 'styled-components';
import IpoApplicationForm from '../../components/Client/IpoApplicationForm/IpoApplicationForm';
import NotificationService from '../../Core/NotificationService'; // 'Core/NotificationService';
import { ClientIpoHandler } from '../../components/Client/ClientIpoHandler';
import { IpoApplicationFormModel } from '../../components/Client/IpoApplicationForm/Models/IpoApplicationFormModel';
import queryString from 'query-string';
import { Redirect } from 'react-router';

export interface Props extends RouteProps {
  children?: React.ReactNode;
}

export interface State {
  isConfirmed: boolean;
}

const TallCol = styled(Col)`
  height: 100%;
  min-height: 200px;
`;

export default class GuestIpoApplicationPage extends React.Component<Props, State> {
  ipoApplicationFormHandler: ClientIpoHandler;

  constructor(props: Props) {
    super(props);
    this.ipoApplicationFormHandler = new ClientIpoHandler(props);

    this.state = { isConfirmed: false };
  }

  componentDidMount() {
    const values = queryString.parse(this.props?.location?.search);
    //  this.confirmJointHolderFormHandler.ConfirmEmail(values.email, values.token).then(x => {
    //  NotificationService.success(
    //    'Email Confirmed',
    //    <>
    //      <p>
    //        Your email address has been confirmed.
    //      </p>
    //    </>, undefined, true
    //  );
    //  // setTimeout(() => { this.setState({ isConfirmed: true }); }, 15000);
    //  this.setState({ isConfirmed: true });

    //  return x;
    //});

    //let state: { from?: string; noPermission?: boolean } = {};
  }

  render() {
    if (this.state.isConfirmed) {
      return <Redirect to="/login" />;
    }

      return <IpoApplicationForm isGuestApplication={true} {...this.props} />;
  }
}
